<div id="page">
  <h1 class="mat-display-1">{{env.name}} - {{env.version}}</h1>
</div>
